import forbiddenError from './ForbiddenError';
import unAuthorizedError from './UnAuthorizedError';
import internalServerError from './InternalServerError';
import notFoundError from './NotFoundError';
import badRequestError from './BadRequestError';
import { HTTP_STATUS } from '../../utils/errorStatus';
import { eventEmitter } from '../../utils/eventEmitter';

const handleError = (error, reject) => {
  const safeReject = typeof reject === 'function' ? reject : () => {};

  if (!error.response) {
    console.error('Network error - backend may be down:', error.message);
    safeReject({ message: error.message || 'Network error - unable to reach server' });
    return;
  }

  const data = error.response?.data;

  if (data?.status === HTTP_STATUS.UNAUTHORIZED || data?.reason === 'Invalid or expired token') {
    unAuthorizedError();
  } else if (data?.status === HTTP_STATUS.FORBIDDEN) {
    forbiddenError();
  } else if (data === HTTP_STATUS.INTERNAL_SERVER_ERROR) {
    internalServerError();
  } else if (data === HTTP_STATUS.NOT_FOUND) {
    safeReject(notFoundError(data));
  } else if (
    data?.errorType === 'RestrictionError' &&
    data?.code === 'FREE_ORGANIZATION_COUNT_LIMIT_EXCEEDED'
  ) {
    eventEmitter.emit('showFreeOrgLimitRestrictionPopup');
    safeReject({ message: 'Free organization limit exceeded' });
  } else if (
    data?.errorType === 'RestrictionError' &&
    data?.code === 'ORGANIZATION_ALLOWED_STORAGE_LIMIT_EXCEEDED'
  ) {
    eventEmitter.emit('showStorageLimitRestrictionPopup');
    safeReject({ message: 'Storage limit exceeded' });
  } else if (data?.status === HTTP_STATUS.BAD_REQUEST) {
    safeReject(badRequestError(data));
  } else if (
    data?.errorType === 'RestrictionError' &&
    data?.code === 'ORGANIZATION_ALLOWED_CONTEST_LIMIT_EXCEEDED'
  ) {
    eventEmitter.emit('showStorageLimitRestrictionPopup');
    safeReject({ message: 'Contest limit exceeded' });
  } else {
    safeReject({ message: data?.reason || error.message || 'Unknown error' });
  }
};

export default handleError;
